import BaseModal from 'components/Modals/BaseModal';
import DeviceSettings from 'features/Integrations/components/DeviceSettings/DeviceSettings';
import { Device } from 'features/Integrations/features/ConnectedDevices/types/MonitoringStation_types';
import { Button } from 'react-bootstrap';
import { BsChevronLeft } from 'react-icons/bs';

type Props = {
  device: Device | null;
  group: any | null;
  stageOpen: boolean;
  usgsOpen: boolean;
  onClearDeviceSettings: () => void;
  onSelectFromGroup: (id: number | string) => void;
};

export default function GenericDeviceModal({
  device,
  group,
  stageOpen,
  usgsOpen,
  onClearDeviceSettings,
  onSelectFromGroup,
}: Props) {
  return (
    <>
      <BaseModal
        show={!!device && !stageOpen && !usgsOpen}
        handleShow={onClearDeviceSettings}
        title={device?.alias}
        size="xl"
        contentStyle={{
          minHeight: 'min(75dvh, calc(100dvh - 12rem))',
          maxHeight: 'calc(100dvh - 8rem)',
          overflowY: 'auto',
          overflowX: 'hidden',
        }}
        bodyClassName="customScrollbar-Y min-h-0"
      >
        {group && (
          <Button variant="link" className="px-0" onClick={onClearDeviceSettings}>
            <BsChevronLeft /> Back
          </Button>
        )}

        {device && <DeviceSettings device={device} onSelectDevice={onSelectFromGroup} />}
      </BaseModal>
    </>
  );
}
